import { createTheme } from "@mui/material/styles";

const brand = {
  navy: "#35317A",
  navyLight: "#5A56A0",
  purple: "#7B2D8E",
  purpleLight: "#B27CC2",
  background: "#F3F1F8",
};

export function getAppTheme(mode) {
  const isDark = mode === "dark";

  return createTheme({
    palette: {
      mode,
      primary: {
        main: isDark ? brand.purpleLight : brand.purple,
      },
      info: {
        main: isDark ? brand.navyLight : brand.navy,
      },
      ...(isDark
        ? {}
        : {
            background: {
              default: brand.background,
              paper: "#ffffff",
            },
          }),
    },
    shape: {
      borderRadius: 10,
    },
    typography: {
      h4: { fontWeight: 700 },
      h6: { fontWeight: 600 },
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            boxShadow: "none",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            textTransform: "none",
            fontWeight: 600,
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 14,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          elevation3: {
            boxShadow: "0 2px 10px rgba(20, 15, 60, 0.08)",
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        },
      },
    },
  });
}
